import { CButton, CFormTextarea, CModal, CModalBody, CModalFooter } from "@coreui/react";

export default function RejectInformationForSendingModal({ visible, setVisible, comment, setComment, docId, handleSend, setCurrentRejectDocId }) {
   return (
      <CModal visible={visible} onClose={() => {
         setVisible(false)
         setComment('')
         setCurrentRejectDocId(null)

      }}>
         <CModalBody>
            <h5>Причина відхилення</h5>
            <CFormTextarea
               rows={4}
               value={comment}
               onChange={(e) => setComment(e.target.value)}
               placeholder="Вкажіть причину повернення на доопрацювання"
               required
            />
         </CModalBody>
         <CModalFooter>
            <CButton color="secondary" onClick={() => setVisible(false)}>
               Відмінити
            </CButton>
            <CButton color="primary" onClick={() => handleSend(docId)} disabled={!comment.trim()}>
               Відправити
            </CButton>
         </CModalFooter>
      </CModal>
   )
}